import { lazy, Suspense, useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { PageRoutes } from "./utils/pageRoutes";
import "./variables.scss";
import "./styles/styles.scss";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import InvestorCenter from "./pages/InvestorCentrer/InvestorCenter";
import Prospectus from "./pages/PPMContent/Prospectus";
import ExecutiveSummary from "./pages/PPMContent/ExecutiveSummary";
import LoginToken from "./components/VerifyPage/loginToken";
import PageRoute from "./PageRoute";
import Why from "./pages/why/why";
import Contact from "./pages/Contact/ContactUs";
import When from "./pages/when/When";
import Intro from "./pages/PPMContent/Intro";
import Question from "./components/Question/Question";
import Qa from "./pages/QA/Qa";
import FactSheet from "./pages/FactSheet/FactSheet";
import Projections from "./pages/Projections/projections";
import SafeFrom from "./pages/SafeFrom/SafeFrom";
import CorporateGovernancePolicy from "./pages/Policy/CorporateGovernancePolicy";
import FAQ from "./pages/FAQ/faq";
import AIExecutiveSummary from "./pages/AIExecutiveSummary/AIExecutiveSummary";
import AntiFraudPolicy from "./pages/Policy/AntiFraudPolicy";
import Whistleblower from "./pages/Policy/Whistleblower";
import DataSecurityPolicy from "./pages/Policy/DataSecurityPolicy";
import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
import TeamsOfUse from "./pages/Policy/TeamsOfUse";
import CookiePolicy from "./pages/Policy/CookiePolicy";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import Insights from "./pages/insights/insights";
import BlogPosts from "./components/Post/BlogPost";
import InvestorRelationsPolicy from "./pages/Policy/InvestorRelationsPolicy";
import { Context } from "./contextApi/contextProvider";
const Home = lazy(() => import("./pages/home/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const WorkFromAnyWhere = lazy(
  () => import("./pages/WorkFrom/WorkFromAnyWhere"),
);
const TiccaProduct = lazy(() => import("./pages/TICCAProduct/TiccaProduct"));
const Innovation = lazy(() => import("./pages/Innovation/Innovation"));
const TableContents = lazy(() => import("./pages/PPMContent/TableContent"));

function App() {
  const location = useLocation();
  const { userLoginData, setLoadingLoader, accessDoc, setAccessDoc } =
    useContext(Context);
  useEffect(() => {
    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  useEffect(() => {
    const handleCopy = (e: ClipboardEvent) => {
      e.preventDefault(); // stop default copy
      if (e.clipboardData) {
        e.clipboardData.setData("text/plain", window.location.origin);
        // Only domain copied
      }
    };

    document.addEventListener("copy", handleCopy);
    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, []);
  return (
    <Suspense fallback={<div></div>}>
      <ToastContainer />
      <CookieConsent />
      <Routes>
        <Route
          path={PageRoutes.home}
          element={
            <PageRoute>
              <Home />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.aboutUs}
          element={
            <PageRoute>
              <AboutUs />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.WorkFromAnywhere}
          element={
            <PageRoute>
              <WorkFromAnyWhere />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.ticcaProduct}
          element={
            <PageRoute>
              <TiccaProduct />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.insights}
          element={
            <PageRoute>
              <Insights />
            </PageRoute>
          }
        />
        <Route
          path={`${PageRoutes.insights}/:slug`}
          element={
            <PageRoute>
              <BlogPosts />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.innovation}
          element={
            <PageRoute>
              <Innovation />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.InvestorCenter}
          element={
            <PageRoute>
              <InvestorCenter />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.ExecutiveSummary}
          element={
            <PageRoute>
              <ExecutiveSummary />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.Intro}
          element={
            <PageRoute>
              <Intro />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.factSheet}
          element={
            <PageRoute>
              <FactSheet />
            </PageRoute>
          }
        />
        <Route path={PageRoutes.LoginToken} element={<LoginToken />} />

        <Route
          path={PageRoutes.WhyChooseUs}
          element={
            //
            <PageRoute>
              <Why />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.ContactUs}
          element={
            <PageRoute>
              <Contact />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.When}
          element={
            <PageRoute>
              <When />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.question}
          element={
            <PageRoute>
              <Question />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.qa}
          element={
            <PageRoute>
              <Qa />
            </PageRoute>
          }
        />

        <Route
          path={PageRoutes.AI_Executive_Summary}
          element={
            <PageRoute>
              <AIExecutiveSummary />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.Projections}
          element={
            <PageRoute>
              <Projections />
            </PageRoute>
          }
        />

        <Route
          path={PageRoutes.SafeFrom}
          element={
            <PageRoute>
              <SafeFrom />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.CorporateGovernancePolicy}
          element={
            <PageRoute>
              <CorporateGovernancePolicy />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.AntiFraudPolicy}
          element={
            <PageRoute>
              <AntiFraudPolicy />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.WhistleblowerPolicy}
          element={
            <PageRoute>
              <Whistleblower />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.DataSecurityPolicy}
          element={
            <PageRoute>
              <DataSecurityPolicy />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.PrivacyPolicy}
          element={
            <PageRoute>
              <PrivacyPolicy />
            </PageRoute>
          }
        />

        <Route
          path={PageRoutes.TeamsOfUse}
          element={
            <PageRoute>
              <TeamsOfUse />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.CookiePolicy}
          element={
            <PageRoute>
              <CookiePolicy />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.InvestorRelationsPolicy}
          element={
            <PageRoute>
              <InvestorRelationsPolicy />
            </PageRoute>
          }
        />
        <Route
          path={PageRoutes.faq}
          element={
            <PageRoute>
              <FAQ />
            </PageRoute>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
